import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'replace',
    standalone: true,
    pure: false
})
export class ReplacePipe implements PipeTransform {


    transform(value: string, replacer?: Record<string, string>) {

        if (!replacer) {
            return value
        }

        return Object.entries(replacer)
            .reduce<string>((returningString, [search, replace]) => returningString.replaceAll(search, replace), value)
    }



}